import React, { useState, useEffect, useMemo } from "react";
import styled from "styled-components";
import { debounce } from "lodash";
import {
  SearchFilterContainer,
  SearchFilterProvider,
  SearchFilterGroup,
  SearchFilterOption,
} from "./library/SearchFilter";

const ApplicationListFilterBar = (props: Props) => {
  const { initialQuery, onQueryChange, filters, onFiltersChange } = props;
  const [query, setQuery] = useState(initialQuery);

  const debouncedQueryChange = useMemo(
    () => debounce(onQueryChange, 350),
    [onQueryChange]
  );

  useEffect(() => {
    debouncedQueryChange.cancel();
    debouncedQueryChange(query);
  }, [query, debouncedQueryChange]);

  return (
    <SearchFilterProvider initialValue={filters} onChange={onFiltersChange}>
      <SearchBar>
        <SearchInput
          name="query"
          placeholder="Search for a candidate or job title"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
        />

        <SearchFilterContainer>
          <SearchFilterGroup defaultCollapsed={false}>
            <SearchFilterOption name="status" value="all" single>
              Show All
            </SearchFilterOption>
            <SearchFilterOption name="status" value="feedback_overdue" single>
              Feedback overdue
            </SearchFilterOption>
            <SearchFilterOption name="status" value="awaiting_feedback" single>
              Awaiting feedback
            </SearchFilterOption>
            <SearchFilterOption name="status" value="interviewing" single>
              Interviewing
            </SearchFilterOption>
            <SearchFilterOption name="status" value="rejected" single>
              Rejected
            </SearchFilterOption>
          </SearchFilterGroup>
        </SearchFilterContainer>
      </SearchBar>
    </SearchFilterProvider>
  );
};

const SearchInput = styled.input`
  flex: 1;
  padding: 0.5rem 1rem;
  border-radius: 3px;
  margin-right: 1rem;
  border: 1px solid ${({ theme }) => theme.colors.gray700};
`;

const SearchBar = styled.div`
  display: flex;
  border-radius: 3px;
  margin-bottom: 1rem;
`;

type Props = {
  initialQuery?: string;
  onQueryChange: (query: string) => void;
  onFiltersChange: (filters: any) => void;
  filters: any;
};

export default ApplicationListFilterBar;
